<template>
    <div class="container">
        <header>
            <span class="btn" @click="goBack"><van-icon name="arrow-left" size="20" /></span>
            <span class="btn" @click="toShare()"><van-icon :name="require('@/assets/imgs/icon17.png')" size="20" /></span>
        </header>
        <div class="detail">
            <div style="padding: 15rem">
                <h5>{{ data.artistName }} <van-icon :name="require('@/assets/imgs/icon20.png')" size="20" /></h5>
                <p class="subtitle">{{ data.firstTitle }}</p>
            </div>
            <div class="line"></div>
            <div class="info">
                <div class="titles">
                    <ul>
                        <li v-for="item in data.otherTitles">{{ item }}</li>
                    </ul>
                    <img :src="data.mainImage">
                </div>
                <p style="margin: 10rem 0;">介绍</p>
                <div v-html="data.introduction"></div>
            </div>
        </div>
        <div class="works">
            <span>作品</span>
            <button>作品主业</button>
        </div>
        <div class="assets">
            <div class="item" v-for="item in data.modelAssets.slice(0,2)">
                <AssetsCard :item="item" />
            </div>
        </div>
    </div>
    <ShareDialog ref="shareDialog" />
</template>
<script setup>
import { onMounted, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import * as api from '@/request/front'
import ShareDialog from '@/views/front/components/ShareDialog.vue'
import AssetsCard from '@/views/front/components/AssetsCard.vue'

const shareDialog = ref(null)

const router = useRouter()
const route = useRoute()
const data = reactive({
    modelAssets: []
})

onMounted(() => {
    api.getArtistDetail(route.query.id).then(res => {
        Object.assign(data, res.data.data)
    })
})

const toShare = () => {
    shareDialog.value.show(location.href)
}
const goBack = () => {
    if (window.history.length > 1) {
        router.back()
    } else {
        router.replace('/')
    }
}
</script>
<style scoped lang="scss">
.container {
    background-color: #F6F6F6;
    padding-bottom: 50rem;
}

header {
    display: flex;
    align-items: center;
    height: 60rem;
    justify-content: space-between;
    padding: 0 20rem;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

.detail {
    margin: 20rem;
    background-color: #fff;

    .line {
        width: 100%;
        height: 1rem;
        background-image: url('@/assets/imgs/line.png');
        background-size: 100%;
    }

    h5 {
        font-size: 20rem;
    }

    .subtitle {
        color: #797979;
        margin-top: 10rem;
    }

    .info {
        padding: 15rem;
        min-height: 150rem;
        .titles {
            display: flex;
            justify-content: space-between;

            ul {
                width: calc(100% - 120rem);

                li {
                    color: #797979;
                    line-height: 20rem;
                    font-size: 12rem;
                }
            }

            img {
                width: 110rem;
                height: 135rem;
                object-fit: cover;
            }
        }
    }


}

.works {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15rem;
    span{
        font-weight: bold;
    }
    button{
        background-color:transparent; border: 1px solid #000000; width: 90rem; height: 26rem;
    }
}

.assets{
    display: flex; padding: 20rem 10rem;
    .item{
        width: 50%; margin: 0 5rem; background-color: #fff;
    }
}
</style>